"use client";

import { c as _c } from "react/compiler-runtime";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@repo/design-system/components/ui/accordion";
import { env } from "~/setup/env";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
export default function CompanyHungary(_props) {
  const $ = _c(8);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      backgroundImage: `url(${env.NEXT_PUBLIC_ASSET_URL}images/jobad/company-bg.webp)`,
      backgroundSize: "cover",
      backgroundPosition: "right"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.hungary_company_HL) {
    t1 = <AccordionTrigger className="[&[data-state=open]>svg]:!rotate-45 flex w-full items-center gap-x-4 text-xl hover:no-underline" icon="cross" iconClassName="h-6 w-6 text-white"><h2 className="font-bold text-3xl md:text-4xl md:hover:underline lg:text-5xl print:text-lg">{t.hungary_company_HL}</h2></AccordionTrigger>;
    $[1] = t.hungary_company_HL;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t.hungary_company_text) {
    t2 = <AccordionContent><div className="mt-8 flex flex-col gap-4 break-words text-lg leading-tight transition-all" dangerouslySetInnerHTML={{
        __html: t.hungary_company_text
      }} /></AccordionContent>;
    $[3] = t.hungary_company_text;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <section className="px-6 py-10 text-lg text-white md:px-10 md:py-20 print:hidden" id="company" style={t0}><div className="mx-auto flex max-w-screen-xl flex-wrap"><Accordion className="w-full" collapsible={true} type="single"><AccordionItem className="border-0" value="company">{t1}{t2}</AccordionItem></Accordion></div></section>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}